import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Restaurantens chaufførflåde',
  [DeliveryProvider.UberDrive]: 'Uber Drive',
  [DeliveryProvider.WoltDrive]: 'Wolt Drive',
};
